"use client";

import ReactDOM from "react-dom";

const CORSARIO = "https://use.typekit.net/lyk3ova.css" as const;
const IVY_JOURNAL = "https://use.typekit.net/iea7ded.css" as const;

export function PreloadFonts() {
  ReactDOM.preload(IVY_JOURNAL, { as: "style" });
  ReactDOM.preload(CORSARIO, { as: "style" });
  return (
    <>
      <link rel="stylesheet" href={IVY_JOURNAL} />
      <link rel="stylesheet" href={CORSARIO} />
    </>
  );
}
